<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-15 18:09:30
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="form.id ? t('common.editConcatModalTitle') : t('common.addConcatModalTitle')"
    width="900px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="form" ref="formRef" v-if="visible">
      <dc-layout-card :span="12">
        <a-col :span="12">
          <div class="flex cos-both-form-item">
            <a-form-item :span="24" :label="t('common.firstName')" style="width: 50%">
              <CosInput v-model:value="form.firstName" :maxlength="50" />
            </a-form-item>
            <a-form-item
              :label="t('common.lastName')"
              name="lastName"
              style="width: 50%"
              class="last-compact"
              :rules="[
                {
                  message: t('common.pleaseInput'),
                  required: true
                },
                {
                  validator: concatNameValidate
                }
              ]"
            >
              <CosInput v-model:value="form.lastName" :maxlength="50" />
            </a-form-item>
          </div>
        </a-col>
        <dc-form-item :label="t('common.mobile')" class="form-item_compact">
          <a-input-group compact>
            <ParamCodesSelect
              :options="paramCodeData.ofbu_area_code"
              v-model:value="form.mobileRegion"
              style="width: 33%"
            />
            <a-form-item
              style="width: 67%"
              class="last-compact"
              name="mobile"
              :rules="{
                validator: (rule, value) => ofbuContactValidate(rule, value, form, formRef)
              }"
            >
              <CosInput v-model:value="form.mobile" :placeholder="t('tips.AJpVtAl4')" />
            </a-form-item>
          </a-input-group>
        </dc-form-item>
        <dc-form-item
          name="skype"
          :label="t('common.skype')"
          :rules="{
            validator: (rule, value) => ofbuContactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.skype" :placeholder="t('tips.AJpVtAl4')" :maxlength="50" />
        </dc-form-item>
        <dc-form-item
          name="email"
          :label="t('common.email')"
          :rules="[
            {
              validator: (rule, value) => ofbuContactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.email" :placeholder="t('tips.AJpVtAl4')" />
        </dc-form-item>

        <dc-form-item :label="t('common.sex')">
          <CosSelect v-model:value="form.sex" :options="dataConfig.genderEnum" allow-clear />
        </dc-form-item>
        <dc-form-item :label="t('common.jobRole')">
          <CosSelect v-model:value="form.jobRole" :options="dataConfig.linkRoleTypeEnum" allow-clear />
        </dc-form-item>
        <dc-form-item :label="t('common.jobDuty')">
          <CosInput v-model:value="form.jobDuty" />
        </dc-form-item>
        <dc-form-item :label="t('common.remark')" :span="24">
          <CosTextarea v-model:value="form.remark" :maxlength="2000" />
        </dc-form-item>
      </dc-layout-card>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { ofbuContactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'
import { cloneDeep } from 'lodash-es'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const emit = defineEmits(['success'])
const props = defineProps({
  contactRefId: {
    type: String
  }
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: PotentialItem['contact']) => {
  console.log(row)
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await customerContactEdit(form.value)
        message.success(t('tips.editSuccess'))
        success('edit')
      } else {
        await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success(t('tips.addSuccess'))
        success('add')
      }
      loading.value = false
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default {
  name: 'ContactsModal'
}
</script>
